import { render, staticRenderFns } from "./SolutionItem.vue?vue&type=template&id=a2762870&scoped=true"
import script from "./SolutionItem.vue?vue&type=script&lang=js"
export * from "./SolutionItem.vue?vue&type=script&lang=js"
import style0 from "./SolutionItem.vue?vue&type=style&index=0&id=a2762870&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2762870",
  null
  
)

export default component.exports